export default __webpack_public_path__ + "static/2021_transportation-96073cdf3ed7aff79d0e5c18b2da59ae.png";